export default __webpack_public_path__ + "static/media/logo_rnr.280b7f77.svg";